<mat-sidenav-container autosize="true" [class.is-dialog]="isDialog" [class.disable-pointer-events]="disablePointerEvents">
  @if (!isDialog) {
    <mat-sidenav [mode]="isPinned ? 'side' : (collapsed ? 'over' : 'side')" [opened]="isPinned || true"
      (clickOutside)="onOutsideClick()" [exclude]="'.menu-btn, .logo-container, .pin-btn'">
      <div [ngClass]="collapsed ? 'logo-container' : 'logo-container-ext'">
        <img (click)="routeToLandingPage()"
          [src]="collapsed ? 'assets/images/logo-exp.svg' : 'assets/images/logo.svg'" alt="Logo"
          [title]="'Go to Landing Page' | translate" [ngClass]="!collapsed ? 'centered-logo' : 'centered-logo-ext'">
        </div>
        @if (!isMobile) {
          <div class="controls-wrapper" [class.expanded-controls]="collapsed && !isPinned">
            @if (collapsed) {
              <div class="pin-btn" [ngClass]="collapsed ? 'pin-btn-collapsed' : 'pin-btn-expanded'">
                <div (click)="togglePin($event)" (keydown.enter)="togglePin($event)" (keydown.space)="togglePin($event)"
                  class="no-outline" tabindex="0" role="button"
                  [attr.aria-label]="isPinned ? 'Unpin Sidebar' : 'Pin Sidebar'"
                  [title]="(isPinned ? 'Unpin Sidebar' : 'Pin Sidebar') | translate">
                  <span class="pin-trigger">
                    <mat-icon [class.pinned]="isPinned">{{ isPinned ? 'push_pin' : 'push_pin' }}</mat-icon>
                  </span>
                </div>
              </div>
            }
            @if (!isPinned) {
              <div class="menu-btn" [ngClass]="collapsed ? 'f-right' : 'f-left'">
                <div (click)="toggleSidenav()" class="no-outline" [class.disabled]="isPinned"
                  [attr.aria-disabled]="isPinned"
                  [title]="isPinned ? ('Cannot collapse while pinned' | translate) : (!collapsed ? ('Expand Sidebar' | translate) : ('Collapse Sidebar' | translate))">
                  <span class="sidenav-trigger">
                    <img alt=""
                      [src]="collapsed ? 'assets/images/arrow-left.svg' : 'assets/images/arrow-right.svg'">
                    </span>
                  </div>
                </div>
              }
            </div>
          }
          <app-sidenav [isCollapsed]="collapsed"></app-sidenav>
          </mat-sidenav>
        }
        <mat-sidenav-content [class.fill-height]="fillHeight">
          <div class="page-content-inner-wrap" [class.fill-height]="fillHeight">
            <ng-content></ng-content>
          </div>
        </mat-sidenav-content>
      </mat-sidenav-container>
